// Sidenav menu config. Plain data — MF-safe to expose. Consumers of the
// layout expose can pass their own list (extend or trim this default) to
// PageFrame/SideNav; this host itself renders the default.
//
// Keep each route in step with the matching catalog entry's routePrefixes in
// shared/federation/remotes.config.ts — a drifting menu link 404s.
export interface MenuItem {
  label: string;
  /** Material Icons Round name. Top-level entries only: a group's children render text alone. */
  icon?: string;
  route?: string;
  /** Nested entries. A parent with children is a collapsible group; its own route is optional. */
  children?: MenuItem[];
}

export const defaultMenuItems: MenuItem[] = [
  { label: "Home", icon: "home", route: "/" },
  {
    label: "Orders",
    icon: "receipt_long",
    children: [{ label: "Customers", route: "/Customers" }],
  },
  // MerchantApp's sidenav links Analytics to /analytics/list (sideNav/sideNavSettings.js).
  { label: "Analytics", icon: "analytics", route: "/analytics/list" },
  // MerchantApp's "Settings" popover, section "Account & User Management"
  // (sideNav/sideNavSettings.js). Only the pages a hosted remote serves are
  // listed: all four are UserManagementUI routes under /user-management.
  // "Email Notifications" (/settings/email-notifications) is a MerchantApp page
  // with no remote here yet, so it is left out rather than linked to a 404.
  {
    label: "Settings",
    icon: "settings",
    children: [
      { label: "My Profile", route: "/user-management/my-profile" },
      { label: "Company Profile", route: "/user-management/company-profile" },
      { label: "User Management", route: "/user-management" },
      {
        label: "Manage Subaccounts",
        route: "/user-management/account-management",
      },
    ],
  },
];
